import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import templateUrl from "emun.retailer/retailer-shipping-location-delete-prompt.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import controller from "emun.retailer/retailer-shipping-location-delete-prompt.controller"

export default {
  open(options) {
    return modals.open(
      angular.extend(
        {
          size: "lg",
          templateUrl: templateUrl,
          resolve: {
            options: () => options
          },
          controller: controller,
          controllerAs: "$ctrl"
        },
        (options || {}).modal
      )
    ).result;
  }
};